<template>
	<section class="container-fluid">
		<div class="offset-xl-3 col-xl-6 offset-md-2 col-md-8">
			<div class="row">
				<div class="col-12">
					<h1>Lots</h1>
					<button v-if="lots.length < 10" class="add-item" @click="addLot">Add Lot <i class="ss-plus ss-glyphish-filled"></i></button>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<List :lots="lots" @edit="editLot" @delete="deleteLot"/>
				</div>
			</div>
			<Add v-if="addOpen" @close="addOpen = false"/>
			<Edit v-if="editOpen" @close="editOpen = false" :lot="selected"/>
			<Delete v-if="deleteOpen" @close="deleteOpen = false" :lot="selected"/>
		</div>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import List from '../Lot/List.vue'
import Edit from '../Lot/Edit.vue'
import Add from '../Lot/Add.vue'
import Delete from '../Lot/Delete.vue'

export default { 
	components: {
		List,
		Edit,
		Add,
		Delete
	},
	data() {
		return {
			selected: null,
			editOpen: false,
			addOpen: false,
			deleteOpen: false
		}
	},
	computed : {
		...mapState({
			lots: state => state.lots.list
		})
	},
	methods: {
		addLot(lot) {
			this.addOpen = true
		},
		editLot(lot) {
			this.selected = lot
			this.editOpen = true
		},
		deleteLot(lot) {
			this.selected = lot
			this.deleteOpen = true
		}
	},
	mounted() {
		this.$store.commit('app/setLoading', true)
		const lots = this.$store.dispatch('lots/getList')

		Promise.all([lots])
		.then(() => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false);
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'An Error occurred, please try later',
				timeout: 3000
			})
		})
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Pages/Lots.vue